import { TabulatorFull as Tabulator } from 'tabulator-tables';
import $ from 'jquery';

$(document).ready(function() {
    // Ne rien faire si l'élément pour le tableau n'existe pas
    if ($('#smt-links-table').length === 0) {
        return;
    }

    const fetchUrl = typeof smt_links_fetch_url !== 'undefined' ? smt_links_fetch_url : null;
    const currentLangIso = typeof current_lang_iso !== 'undefined' ? current_lang_iso : 'fr';
    const currentLangId = typeof current_lang_id !== 'undefined' ? current_lang_id : 1; // Default to 1 for 'fr'
    const currentProductId = typeof current_product_id !== 'undefined' ? current_product_id : 0; // Get product ID

    if (!fetchUrl) {
        console.error('URL de récupération des liens SMT manquante.');
        $('#smt-links-table-container').html('<div class="alert alert-danger">Erreur: URL de données manquante.</div>');
        return;
    }

    // --- Définitions des traductions pour Tabulator ---
    const tabulatorLangs = {
        "fr": {
            "pagination":{
                "first":"Première",
                "first_title":"Première Page",
                "last":"Dernière",
                "last_title":"Dernière Page",
                "prev":"Précédent",
                "prev_title":"Page Précédente",
                "next":"Suivant",
                "next_title":"Page Suivante",
                "all":"Tout",
                "page_size":"Taille de page",
                "page_title":"Afficher la page",
            }
        },
        "en": {
            "pagination":{
                "first":"First",
                "first_title":"First Page",
                "last":"Last",
                "last_title":"Last Page",
                "prev":"Prev",
                "prev_title":"Prev Page",
                "next":"Next",
                "next_title":"Next Page",
                "all":"All",
                "page_size":"Page Size",
                "page_title":"Show Page",
            }
        },
        "es": {
            "pagination":{
                "first":"Primera",
                "first_title":"Primera Página",
                "last":"Última",
                "last_title":"Última Página",
                "prev":"Anterior",
                "prev_title":"Página Anterior",
                "next":"Siguiente",
                "next_title":"Página Siguiente",
                "all":"Todo",
                "page_size":"Tamaño de página",
                "page_title":"Mostrar página",
            }
        }
    };

    const columnTitles = {
        fr: {
            brand: "Marque",
            type: "Type",
            model: "Modèle",
            quantity: "Qté. Recom.",
            description: "Description Spécifique"
        },
        en: {
            brand: "Brand",
            type: "Type",
            model: "Model",
            quantity: "Rec. Qty.",
            description: "Specific Description"
        },
        es: {
            brand: "Marca",
            type: "Tipo",
            model: "Modelo",
            quantity: "Cant. Recom.",
            description: "Descripción Específica"
        }
    };

    const placeholderTexts = {
        fr: "Aucune liaison moteur trouvée pour ce produit.",
        en: "No engine links found for this product.",
        es: "No se encontraron compatibilidades de motor para este producto."
    };

    const titles = columnTitles[currentLangIso] || columnTitles.fr; // Fallback sur le français

    // Initialisation de Tabulator
    const table = new Tabulator("#smt-links-table", {
        layout: "fitData", // Ajuste les colonnes au contenu
        placeholder: placeholderTexts[currentLangIso] || placeholderTexts.fr,
        ajaxURL: fetchUrl,
        ajaxParams: { lang_id: currentLangId, product_id: currentProductId },
        ajaxResponse: function(url, params, response) {
            if (response.data) {
                return response.data;
            } else {
                console.error('Erreur lors du chargement des données:', response.error);
                return [];
            }
        },
        pagination: "local",
        paginationSize: 5,
        locale: currentLangIso,
        langs: tabulatorLangs,
        columns: [
            { title: titles.brand, field: "brand_name", headerFilter: "input", formatter: "plaintext" },
            { title: titles.type, field: "type_name", headerFilter: "input", formatter: "plaintext" },
            { title: titles.model, field: "model_name", headerFilter: "input", formatter: "plaintext" },
            { title: titles.quantity, field: "recommended_qty", hozAlign: "center", sorter: "number", headerSort: false },
            {
                title: titles.description,
                field: (currentLangIso === "fr" ? "specific_description_fr" : (currentLangIso === "es" ? "specific_description_es" : "specific_description_en")),
                formatter: "textarea",
                headerFilter: "input",
            },
        ],
    });

    // Indicateur de chargement
    table.on("dataLoading", function(){
        $('#smt-links-table-container').append('<div class="loading-overlay">Chargement des données...</div>');
    });

    table.on("dataLoaded", function(){
        $('#smt-links-table-container').find('.loading-overlay').remove();
    });

    table.on("dataError", function(error){
        console.error("Erreur de chargement des données Tabulator:", error);
        $('#smt-links-table-container').html('<div class="alert alert-danger">Erreur lors du chargement des données.</div>');
    });
});